"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSubscriptionHandlers = void 0;
var _checkoutUtils = require("@ori/checkout-utils");
var _logger = require("@ori/logger");
var _react = require("react");
var _contexts = require("../../contexts");
var _updateBasketItem = require("../../utils/updateBasketItem");
const useSubscriptionHandlers = subscriptionHandlersOptions => {
  const logger = (0, _logger.useLogger)('useSubscriptionHandlers');
  const {
    setIsLoadingAdditionalData
  } = (0, _contexts.useBasketContext)();
  const {
    itemCode,
    lineNumber,
    placement,
    quantity,
    requestedQuantity
  } = subscriptionHandlersOptions;
  const [subscriptionLineNumber, setSubscriptionLineNumber] = (0, _react.useState)(0);
  const onSubscribeClick = (0, _react.useCallback)(() => {
    const showSubscriptionWizard = new CustomEvent('open-subscription-wizard', {
      detail: {
        type: 'Subscription',
        customerType: 'All',
        productCode: itemCode
      }
    });
    setSubscriptionLineNumber(lineNumber);
    window.dispatchEvent(showSubscriptionWizard);
    return subscriptionLineNumber;
  }, [itemCode, lineNumber, subscriptionLineNumber]);
  const onSubscriptionSaved = (0, _react.useCallback)(async () => {
    try {
      setIsLoadingAdditionalData(true);
      if (subscriptionLineNumber !== 0) {
        await (0, _updateBasketItem.updateBasketItem)({
          itemCode,
          lineNumber: subscriptionLineNumber,
          placement,
          previousQuantity: requestedQuantity,
          quantity: quantity - 1
        });
      }
    } catch (error) {
      (0, _checkoutUtils.showErrorNotification)();
      logger.error(error);
    } finally {
      setIsLoadingAdditionalData(false);
    }
  }, [setIsLoadingAdditionalData, subscriptionLineNumber, itemCode, placement, requestedQuantity, quantity, logger]);
  return {
    onSubscribeClick,
    onSubscriptionSaved,
    subscriptionLineNumber
  };
};
exports.useSubscriptionHandlers = useSubscriptionHandlers;